import {Component, OnInit, Inject, EventEmitter, Output} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Router} from '@angular/router';
import {NgForm, FormsModule} from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormArray, FormControl} from '@angular/forms';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import {BoardService} from "../../../services/board/board.service";
import {SocialMediaPostForBoard} from '../../../modele/boardModel';
import {Gif} from '../../../modele/gifModel';
import {PostForBoardService} from '../../../services/post_for_board/post-for-board.service';
import {NGXLogger} from "ngx-logger";
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {EndpointService} from "../../../services/endpoint/endpoint.service";
import {GiphyService} from "../../../services/social-media/giphy.service";
import {SnackbarComponent} from '../../../components/alerts/snackbar/snackbar.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NgxLinkifyjsService} from "ngx-linkifyjs";

@Component({
    selector: 'app-create-board-post',
    templateUrl: './create-board-post.component.html',
    styleUrls: ['./create-board-post.component.scss']
})
export class CreateBoardPostComponent implements OnInit {
    board_name: string;
    owner_name: string;

    channelsFormGroup: FormGroup;
    createPostFormGroup: FormGroup;
    gifFormGroup: FormGroup;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    showButton: boolean = false;
    loading: boolean = false;
    message = '';
    value = '';
    emojis: Array<any> = [];
    filteredStates: Observable<any[]>;
    searchValue = new FormControl();
    userLen;
    openEmojis;
    showEmojiPicker = false;
    resourcesLoaded: boolean;
    sets = [
        'google',
    ]
    set = 'google';
    showGifs: boolean = false;
    gifPreview: Array<Gif> = [];
    oneGifIsSelected: boolean = false;
    selectedGifImage = Gif;
    selectedGifUrl: string = null;
    showImageCropper: boolean = false;
    errorMsgForFalseImage: boolean = false;
    openGifTool: boolean = false;
    openImageTool: boolean = false;
    openVideoTool: boolean = false;
    openEmojisTool: boolean = false;
    private log_prefix = this.constructor.name + ":";

    constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
                private bottomSheet: MatBottomSheet,
                private router: Router,
                private _formBuilder: FormBuilder,
                private boardService: BoardService,
                private postForBoardService: PostForBoardService,
                private logger: NGXLogger,
                private endpointSrv: EndpointService,
                private giphySrv: GiphyService,
                private snackBar: MatSnackBar,
                public hashTagSrv: NgxLinkifyjsService,) {
        this.board_name = data.board_name
        this.logger.info("check mal bitte", data)
        this.endpointSrv.getEmojisCall().subscribe(data => {
            let emos = data['emojis']
            this.emojis = emos
            this.logger.info("hier die emos", this.emojis)
        })
        this.filteredStates = this.searchValue.valueChanges.pipe(
            startWith(''),
            map(emojis => emojis ? this._filterStates(emojis) : this.emojis.slice()));
    }

    private _filterStates(value: string): any[] {
        const filterValue = value.toLowerCase();
        this.userLen = this.emojis.length - this.emojis.filter(emojis => emojis.emojis_category.toLowerCase().indexOf(filterValue)).length;
        return this.emojis.filter(emojis => emojis.emojis_category.toLowerCase().indexOf(filterValue) === 0);
    }

    getEmo(val) {
        if (this.value.length == 0) {
            const {value} = this;
            const text = `${value}${val}`;
            this.value = text;
        }
        else {
            this.value = ``
            const {value} = this;
            const text = `${value}${val}`;
            this.value = text;
        }

    }


    ngOnInit() {

        this.channelsFormGroup = this._formBuilder.group({
            post_text: [''],
            post_link: [''],
            post_link_beschreibung: [''],
        });
        this.showImageCropper = false;

        this.createPostFormGroup = this._formBuilder.group({
            post_board_gif: [''],
            post_board_id: [this.data.board_id],
            post_board_image: [''],
            post_board_text: [''],
            post_board_video: [''],
            post_board_hashtag_list: [''],
        });
        this.gifFormGroup = this._formBuilder.group(
            {
                searchValue: [''],
            });
    }

    closeBottomSheet() {
        this.bottomSheet.dismiss();
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
    }

    imageLoaded() {
        this.showImageCropper = true;
        this.errorMsgForFalseImage = false
        // show cropper
    }

    cropperReady() {
        this.showButton = true

        // cropper ready
    }

    loadImageFailed() {
        this.errorMsgForFalseImage = true
        // show message
    }

    onSubmitCreate(post_image) {
        this.loading = true;
        this.createPostFormGroup.patchValue({
            post_board_image: post_image,
        });
        let {post_board_video} = this.createPostFormGroup.value

        let {_files} = post_board_video;

        const formData = new FormData();

        if (this.createPostFormGroup.value.post_board_video != '') {
            formData.set("post_board_video", _files[0]);
        }
        if (this.createPostFormGroup.value.post_board_video == '') {
            formData.set("post_board_video", '');
        }

        formData.set("post_board_id", this.createPostFormGroup.get('post_board_id').value);
        formData.set("post_board_text", this.createPostFormGroup.get('post_board_text').value);
        formData.set("post_board_image", this.createPostFormGroup.get('post_board_image').value);
        formData.set("post_board_gif", this.createPostFormGroup.get('post_board_gif').value);

        let board_post_test_input = this.createPostFormGroup.get('post_board_text').value;
        let hashTagsInPostText = this.hashTagSrv.find(board_post_test_input).filter(ele => ele.type == "hashtag").map(ele => ele.value);
        if (hashTagsInPostText.length > 0) {
            formData.set("post_board_hashtag_list", JSON.stringify({hashtag_list: hashTagsInPostText}));
        }

        this.logger.info(this.log_prefix, "extracted hashtags:", hashTagsInPostText);
        this.endpointSrv.createPostForBoardsMultimedia(formData);
        this.endpointSrv.getPostUploadState().subscribe(state => {
            if (state == true) {
                this.bottomSheet.dismiss();
                this.loading = false
            }
        });

        // this.testtext = this.hashSrv.find('For help with GitHub.com, #please email support@github.com');
        // this.hashtags = this.testtext.map(data => data.type == 'hashtag');
    }

    addEmoji2(emo) {
        const {message} = this;
        const text = `${message}${emo}`;
        this.message = text;
    }

    toggleEmojiPicker() {
        this.showEmojiPicker = !this.showEmojiPicker;
    }

    addEmoji(event) {
        const {message} = this;
        const text = `${message}`;
        if (message == null) {
            this.message = "" + event.emoji.colons
        }
        else {
            this.message = text + event.emoji.colons;

        }
        // this.showEmojiPicker = false;
    }

    onFocus() {
        this.showEmojiPicker = false;
    }

    onBlur() {
    }

    onSubmitSuche() {
        this.gifPreview = []
        this.giphySrv.searchForPost(this.gifFormGroup.value.searchValue).subscribe(data => {
            data.map(giff => {
                let gifs = new Gif(
                    giff.Title,
                    giff.bitly_url,
                    giff.images.fixed_width.url,
                    giff.images.original.url,
                    giff.username,
                    giff.url
                )
                this.gifPreview.push(gifs)
            })
        })
        setTimeout(() => {
            this.gifFormGroup.reset()
        }, 1000)
    }

    selectedGif(gif) {
        this.oneGifIsSelected = true;
        this.selectedGifImage = gif.embed_url;
        this.selectedGifUrl = gif.embed_url;
        this.createPostFormGroup.patchValue({
            post_board_gif: gif.original_image,
        });
        this.snackBar.openFromComponent(SnackbarComponent, {
            panelClass: "snackbar",
            duration: 1500,
            horizontalPosition: 'center',
            data: {
                message: 'keyword_$396',
                boardname: '',
                icon: 'add'
            }
        });
    }

    gifDelete() {
        this.oneGifIsSelected = false;
        this.selectedGifImage = null;
        this.selectedGifUrl = null;
        this.createPostFormGroup.patchValue({
            post_board_gif: '',
        });

        this.snackBar.openFromComponent(SnackbarComponent, {
            panelClass: "snackbar",
            duration: 1500,
            horizontalPosition: 'center',
            data: {
                message: 'keyword_$397',
                boardname: '',
                icon: 'delete'
            }
        });
    }

    showImageCropperfunc() {
        if (this.showImageCropper == true) {
            this.showImageCropper = false
        }
        if (this.showImageCropper == false) {
            this.showImageCropper = true
        }

    }

    imageDelete() {
        this.croppedImage = '';
        this.fileChangeEvent(this.croppedImage)
        this.createPostFormGroup.patchValue({
            post_board_image: '',
        });
        this.snackBar.openFromComponent(SnackbarComponent, {
            panelClass: "snackbar",
            duration: 1500,
            horizontalPosition: 'center',
            data: {
                message: 'keyword_$402',
                boardname: '',
                icon: 'delete'
            }
        });
    }

    openGifToolFunc() {
        this.openGifTool = true;
        this.openImageTool = false;
        this.openVideoTool = false;
        this.showEmojiPicker = false;
    }

    openImageToolFunc() {
        this.openGifTool = false;
        this.openImageTool = true;
        this.openVideoTool = false;
        this.showEmojiPicker = false;
    }

    openVideoToolFunc() {
        this.openGifTool = false;
        this.openImageTool = false;
        this.openVideoTool = true;
        this.showEmojiPicker = false;
    }

    openEmojisToolFunc() {
        this.openGifTool = false;
        this.openImageTool = false;
        this.openVideoTool = false;
        this.openEmojisTool = true;
    }
}
